var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3351 18.0544C12.7831 18.0544 12.3351 17.6064 12.3351 17.0543V0.999522C12.3351 0.447516 12.7831 -0.000488281 13.3351 -0.000488281C13.8871 -0.000488281 14.3351 0.447516 14.3351 0.999522V17.0543C14.3351 17.6064 13.8871 18.0544 13.3351 18.0544Z",
    fill: "#666E7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3344 18.0561C13.069 18.0561 12.813 17.9507 12.6264 17.7614L8.73832 13.8587C8.34898 13.4667 8.35031 12.8334 8.74098 12.444C9.13299 12.0547 9.76499 12.0547 10.1543 12.4467L13.3344 15.64L16.5144 12.4467C16.9037 12.0547 17.5357 12.0547 17.9277 12.444C18.3184 12.8334 18.3197 13.4667 17.9304 13.8587L14.0424 17.7614C13.8557 17.9507 13.5997 18.0561 13.3344 18.0561Z",
    fill: "#666E7D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1087_25228",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 27,
    height: 19
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.31006H26.6667V24.6356H0V6.31006Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1087_25228)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7669 24.6356H5.91339C2.65336 24.6356 0 21.9835 0 18.7222V12.2088C0 8.95542 2.64669 6.31006 5.90139 6.31006H7.15607C7.70808 6.31006 8.15608 6.75806 8.15608 7.31007C8.15608 7.86207 7.70808 8.31008 7.15607 8.31008H5.90139C3.74937 8.31008 2.00002 10.0581 2.00002 12.2088V18.7222C2.00002 20.8809 3.7547 22.6356 5.91339 22.6356H20.7669C22.9162 22.6356 24.6669 20.8849 24.6669 18.7355V12.2235C24.6669 10.0648 22.9109 8.31008 20.7549 8.31008H19.5122C18.9602 8.31008 18.5122 7.86207 18.5122 7.31007C18.5122 6.75806 18.9602 6.31006 19.5122 6.31006H20.7549C24.0149 6.31006 26.6669 8.96342 26.6669 12.2235V18.7355C26.6669 21.9889 24.0189 24.6356 20.7669 24.6356Z",
    fill: "#666E7D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.c8f688224591737f5775bf540b7f5bf1.svg";
export { ForwardRef as ReactComponent };